import React from "react";

export class SpeciesCounts extends React.Component {
  
  componentWillReceiveProps(newProps) {
    this.setState({speciesCounts: newProps.speciesCounts});
  }
  
  render() {
    var result = this.props.speciesCounts.filter(function(v, i) {
        return (v.id != "-LX4j879bTHwdelz0Uk6");
      })
    var result2 = result.filter(function(v, i) {
    return (v.id != "-LX4iau5LlrGzTyiczlU");
    })
    return (
      <div className="speciesCountsBox">
        {result2.map(specie => (
        <div className='speciesBox'>{specie.speciesCount}</div>
        ))}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/roosterrodeo/comps/SpeciesCounts.js